/** Constants related to the goal ratio planting plan param used during advanced script creation.
 *
 * naming:
 *  plantingPlan = planting plan params during advanced RX creation, e.g. "50"
 *  hank = Hank service naming used by API, e.g. "mediumEconomic"
 *  index = 0-based index to 5 possible goal ratio settings
 */

export const plantingPlanGoalRatios = [0, 25, 50, 75, 100];

export const hankGoalRatios = [
  'highestEconomic', 'mediumEconomic', 'balancedEconomicYield', 'mediumYield', 'highestYield' ];

export const plantingPlanToHankGoalRatio = plantingPlanGoalRatios.reduce((result, key, index) =>
{ result[key] = hankGoalRatios[index]; return result; }, {});
